<div class="col-xs-12">
  <div class="btn-group">
    <div class="btn btn-default btn-sm btn-action" ng-click="goToIndex()">Voltar</div>
    <button type="button" class="btn btn-primary btn-sm btn-action" ng-print print-element-id="print-ocorrencia">
      Imprimir <i class="glyphicon glyphicon-print"></i>
    </button>
    <div class="btn btn-primary btn-sm" ng-click="doClose()" ng-if="permissions.maquina.canManage && isOpened(ocorrencia)"
         uib-tooltip="Fechar Ocorrência" tooltip-placement="top">
      Fechar <i class="glyphicon glyphicon-minus"></i>
    </div>
    <div class="btn btn-primary btn-sm" ng-click="createComment()" ng-if="permissions.maquina.canManage"
         uib-tooltip="Adicionar Comentário" tooltip-placement="top">
      Comentário <i class="glyphicon glyphicon-comment"></i>
    </div>
    <div class="btn btn-primary btn-sm btn-action" ng-click="edit()" ng-if="permissions.maquina.canManage">
      Editar <i class="glyphicon glyphicon-pencil"></i>
    </div>
    <div class="btn btn-danger btn-sm btn-action" ng-click="delete()" ng-if="permissions.maquina.canManage">
      Excluir <i class="glyphicon glyphicon-trash"></i>
    </div>
  </div>
</div>
